import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";

const COLORS = ["#ffc107", "#0d6efd", "#28a745", "#6f42c1"];

export default function PaymentDonutChart({ data }) {
  return (
    <div className="card shadow-sm border-0 h-100">
      <div className="card-body">
        <div className="d-flex justify-content-between mb-3">
          <h6 className="fw-semibold mb-0">
            Payments By Payment Methods
          </h6>
          <select className="form-select form-select-sm w-auto">
            <option>This Year</option>
          </select>
        </div>

        <div style={{ height: 170 }}>
          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={data}
                innerRadius={60}
                outerRadius={80}
                paddingAngle={3}
                dataKey="value"
              >
                {data.map((_, index) => (
                  <Cell key={index} fill={COLORS[index]} />
                ))}
              </Pie>
            </PieChart>
          </ResponsiveContainer>
        </div>

        <div className="text-center mt-2">
          <h5 className="fw-bold">+14%</h5>
          <small className="text-muted">Vs Last Year</small>
        </div>
      </div>
    </div>
  );
}